function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Path 0",
    style: {
      fill: "currentColor",
      stroke: "currentColor"
    },
    d: "m202.8 29.4c-55.3 0.6-101 1.5-101.5 1.9-0.4 0.5-2.4 91.5-4.3 202.2-1.9 110.7-3.1 201.7-2.7 202.2 0.5 0.4 68.3-0.6 150.8-2.2l149.9-3v-402.5c-70.9 0.3-136.8 0.8-192.2 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    strokeWidth: "0.75rem",
    style: {
      fill: "current",
      stroke: "current"
    },
    fillRule: "evenodd",
    d: "m411.8 43v371.6c0 18.1-14.7 32.8-32.7 32.8h-45.5v38.1c0 5-2.2 9.7-6.1 12.8-3.8 3.1-8.9 4.3-13.7 3.2l-226.1-50.1c-7.5-1.6-12.8-8.3-12.8-15.9l-0.2-392.5c0-18.1 14.6-32.8 32.7-32.8h271.7c18 0 32.7 14.7 32.7 32.8zm-120 193.5v-51c0-4.8-3.3-9.1-8-10.2l-154-38.9c-6.7-1.7-13.2 3.4-13.2 10.3v51c0 4.8 3.3 9 8 10.2l154 38.9c6.7 1.7 13.2-3.4 13.2-10.3zm87.2 178v-371.5h-224.1l165.7 33.9c7.6 1.5 13 8.2 13 16v321.7zm0.1 0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.943efdaf60ae2da59de74e78fb05fac5.svg";
export { ForwardRef as ReactComponent };